import store from '@/framework/store'
import routeStore from './routeStore'

const options = {
  install () {
    store.registerModule('route', routeStore)
  }
}

export default options
